export const API_EXTERNAL_ENDPOINT = 'legal-info-page'

export const API_INTERNAL_ENDPOINT = 'strapi/legal-info-page'
